import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import last from 'lodash/last';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import allRoutes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultHeader from './DefaultHeader';

import { logOutUser } from '../../modules/agent';
import { loadAgency, getAgencies } from '../../modules/agency';
import { loadMailingList } from '../../modules/mailing-list';
import { loadProjectList } from '../../modules/projects';
import { loadEnrollmentStatus } from '../../modules/enrollment';
import { SERVER_URL } from '../../modules/services/constants.service';

let isFirstLoad = true;

class DefaultLayout extends Component {
  getFilteredNavigation = (nav) => {
    const { user: { roles: userRoles = [] } } = this.props;
    const items = nav.items.filter((item) => {
      if (item.children) {
        item.children = item.children.filter((child) => {
          return child.roles.some((role) => userRoles.includes(role))
        })
      }
      return !item.roles || item.roles.some((role) => userRoles.includes(role));
    });
    if (last(items) && last(items).divider) {
      items.pop();
    }
    return { ...nav, items };
  };

  componentWillMount() {
    const { user, logOutUser, loadAgency, getAgencies, loadMailingList, loadProjectList, loadEnrollmentStatus } = this.props;

    if (user && isFirstLoad) {
      axios.get(`${SERVER_URL}/api/AppUsers/${user.id}`)
      .then(({data}) => {
        if (data.id !== user.id) {
          logOutUser();
        }
        else {
          getAgencies();

          if (user.agencyId && user.agencyId !== '-1') {
            loadAgency(user.agencyId);
          }  

          loadProjectList();
          loadMailingList();
          loadEnrollmentStatus();

          isFirstLoad = false;
        }
      })
      .catch(err => {
        logOutUser();
      });
    }
  }

  render() {
    const { user: { roles: userRoles = [] } } = this.props;
    const routes = allRoutes.filter(r => {
      return !r.roles || r.roles.some((role) => userRoles.includes(role));
    });

    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={this.getFilteredNavigation(navigation)} {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <AppBreadcrumb appRoutes={routes}/>
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                        <route.component {...props} />
                      )} />)
                      : (null);
                  },
                )}
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Container>
          </main>
          <AppAside fixed hidden>
            <DefaultAside />
          </AppAside>
        </div>
        {/* <AppFooter>
          <DefaultFooter />
        </AppFooter> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logOutUser,
  loadAgency,
  getAgencies,
  loadMailingList,
  loadProjectList,
  loadEnrollmentStatus
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultLayout);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js